$(document).on('click', '[data-shipping-address-select]', function (event) {
  event.preventDefault();
  $.ajax({
    method: 'GET',
    url: $(this).attr('href'),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('submit', '[data-default-shipping-address-select]', function (event) {
  event.preventDefault();
  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');
  $reveal.addClass('loading');

  $.ajax({
    method: 'POST',
    url: $form.attr('action'),
    data: $form.serialize(),
  }).then(() => {
    $reveal.removeClass('loading').addClass('loaded');
    document.location.reload();
  });
});

// 2fa print backup tokens
$(document).on('click', '[data-2fa-backup-token-print]', (event) => {
  event.preventDefault();
  const $printTarget = $('[data-2fa-backup-token-list]');
  const myWindow = window.open('', 'PRINT', 'height=400,width=600');
  myWindow.document.write(`
    ${$printTarget[0].innerHTML}
  `);
  myWindow.focus(); // necessary for IE >= 10*/
  myWindow.document.close(); // necessary for IE >= 10
  myWindow.print();
});
